<template>
  <div class="flow-root" v-if='props.query.getItems()?.length'>
    <div class="overflow-x-auto">
      <div class="inline-block min-w-full">
        <div class="relative">
          <div v-if="props.query.hasAnySelected()" class="absolute left-14 top-0 flex h-12 items-center space-x-3 bg-white sm:left-12">
            <button v-for='action in bulkActions' type="button" class="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white" @click='action.processor'>{{ action.title }}</button>
          </div>
          <table class="min-w-full table-fixed divide-y divide-gray-300">
            <thead>
              <tr>
                <th scope="col" class="relative px-7 sm:w-12 sm:px-6">
                  <input type="checkbox" class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-jananavy-600 focus:ring-jananavy-600" :checked="props.query.hasAnySelected()" :indeterminate="props.query.hasSomeSelected()" @change="props.query.toggleAllSelected()" />
                </th>
                <th v-for='column in props.columns' scope="col" class="py-3.5 pr-3 text-left text-sm font-semibold text-gray-900 min-w-36">
                  <template v-if='column.sortable'>
                    <button href="#" class="group inline-flex" @click='props.query.toggleSort(column.key)'>
                      {{ column.name }}
                      <span class="invisible ml-2 flex-none rounded text-gray-400 group-hover:visible group-focus:visible" v-if='!props.query.isSortedBy(column.key)'>
                        <ChevronUpIcon class="h-5 w-5" aria-hidden="true" v-if='props.query.getSortOrder() === -1' />
                        <ChevronDownIcon class="h-5 w-5" aria-hidden="true" v-if='props.query.getSortOrder() === 1' />
                      </span>
                      <span class="ml-2 flex-none rounded bg-gray-100 text-gray-900 group-hover:bg-gray-200" v-if='props.query.isSortedBy(column.key)'>
                        <ChevronUpIcon class="h-5 w-5" aria-hidden="true" v-if='props.query.getSortOrder() === -1' />
                        <ChevronDownIcon class="h-5 w-5" aria-hidden="true" v-if='props.query.getSortOrder() === 1' />
                      </span>
                    </button>
                  </template>
                  <template v-else>
                    {{ column.name }}
                  </template>
                </th>
                <!-- <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-3">
                  <span class="sr-only">Edit</span>
                </th> -->
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
              <tr v-for="item in props.query.getItems()" :key="item.id">
                <td class="relative px-7 sm:w-12 sm:px-6">
                  <input type="checkbox" class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-jananavy-600 focus:ring-jananavy-600" :value="item" v-model="item.$isSelected" />
                </td>
                <td v-for='column in props.columns' class="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">
                  <Component v-if='column.cell' :is='column.cell' :item='item' :column='column' v-bind='column.props || {}' />
                  <slot v-else :name='`cell-${column.key}`' :item='item' :column='column' />
                </td>
                <!-- <td class="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
                  <a href="#" class="text-jananavy-600 hover:text-jananavy-900">
                    Edit<span class="sr-only">, </span>
                  </a>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  
import { ref, computed, watch } from 'vue';

import { RouterLink } from 'vue-router';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/20/solid';

import StringCell from '@/components/cells/string-cell.vue';

const props = defineProps({
  query: Object,
  columns: Array,
  bulkActions: Array
});

</script>